<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{
            name: 'onboarding-questions'
          }"
          >Onboarding Questions
        </router-link>
      </v-toolbar-title>
    </v-app-bar>

    <question-form @submit="submit"></question-form>
  </div>
</template>

<script>
import { mdiChevronLeft } from '@mdi/js'
import { mapActions } from 'vuex'
import ControlsMixin from '@/utils/mixins/Controls'
import QuestionForm from './components/QuestionForm.vue'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'CreateOnboardingQuestionPage',

  mixins: [ControlsMixin],

  components: {
    AppBarNavIcon,
    QuestionForm
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft
      }
    }
  },

  methods: {
    ...mapActions({
      saveProjectQuestion: 'question/storeQuestion'
    }),

    async submit(form) {
      let formData = form.$data()
      formData.tips = formData.tips.map(tip => tip.name)
      formData.sub_questions = formData.sub_questions.map(
        question => question.name
      )

      formData.choices = formData.choices.map(choice => ({
        name: choice.name,
        resource_ids: choice.resources.map(r => r.id)
      }))

      try {
        form.$busy = true
        await this.saveProjectQuestion(formData)

        form.$reset()

        this.$store.dispatch('showSnackbar', {
          message: 'Onboarding question created',
          color: 'success'
        })

        this.$router.replace({
          name: 'onboarding-questions'
        })
      } catch (err) {
        if (err.response.status === 422) {
          form.$setErrors(err.response.data.errors)
        }
      } finally {
        form.$busy = false
      }
    }
  }
}
</script>
